module.exports = __webpack_public_path__ + "static/me-0b561b07de7abd8bc151622dbe05e0a3.jpg";